// Vendor
import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../comparables-modal/comparables-modal.component";
import * as i2 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
export class ComparablesModalButtonComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.modalText = '';
        this.securityId = eltRef.nativeElement.getAttribute('securityId');
        this.benchmarkSecurityId = eltRef.nativeElement.getAttribute('benchmarkSecurityId');
        this.searchType = eltRef.nativeElement.getAttribute('searchType');
        this.maxComparables = parseInt(eltRef.nativeElement.getAttribute('maxComparables'), 10);
        this.maxDisplayComparables = parseInt(eltRef.nativeElement.getAttribute('maxDisplayComparables'), 10);
        this.showRestoreDefaults = eltRef.nativeElement.getAttribute('showRestoreDefaults') === 'True';
    }
    ngOnInit() {
        this.modalText = `Drag and drop to reorder or search security to add. Only top 
         ${this.maxDisplayComparables} comparables are shown.`;
    }
}
ComparablesModalButtonComponent.ɵfac = function ComparablesModalButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ComparablesModalButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ComparablesModalButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ComparablesModalButtonComponent, selectors: [["ycn-comparables-modal-button"]], inputs: { securityId: "securityId", benchmarkSecurityId: "benchmarkSecurityId", searchType: "searchType", maxComparables: "maxComparables", maxDisplayComparables: "maxDisplayComparables", showRestoreDefaults: "showRestoreDefaults" }, standalone: false, decls: 7, vars: 9, consts: [["comparablesModal", ""], [1, "panel-action"], [1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [3, "benchmarkSecurityId", "maxComparables", "maxDisplayComparables", "securityId", "searchType", "shouldReloadPage", "showRestoreDefaults", "modalText"]], template: function ComparablesModalButtonComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
        i0.ɵɵlistener("click", function ComparablesModalButtonComponent_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r1); const comparablesModal_r2 = i0.ɵɵreference(6); return i0.ɵɵresetView(comparablesModal_r2.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(2, "svg", 3);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(3, "span");
        i0.ɵɵtext(4, "Edit comparables");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(5, "ycn-comparables-modal", 4, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-edit");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("benchmarkSecurityId", ctx.benchmarkSecurityId)("maxComparables", ctx.maxComparables)("maxDisplayComparables", ctx.maxDisplayComparables)("securityId", ctx.securityId)("searchType", ctx.searchType)("shouldReloadPage", true)("showRestoreDefaults", ctx.showRestoreDefaults)("modalText", ctx.modalText);
    } }, dependencies: [i1.ComparablesModalComponent, i2.IconDirective], encapsulation: 2 });
